import React from "react";
import LoanApplication from "../../../models/loan/loanApplication";
import Table from "react-bootstrap/esm/Table";
import "./DealerPurchaseSection.css";
import loanApplicationUtility from "../../../utilities/LoanApplicationUtility";
import EquipmentInformation from "models/dealerPurchase/equipmentInformation";
import { LoanType } from "shared/Enums";

interface DealerPurchaseSectionProps {
  loanDetails: LoanApplication
}

const EquipmentLoans = [LoanType.DealerPurchase, LoanType.EquipmentRefinance, LoanType.EquipmentAuctionPurchase];

export default class DealerPurchaseSection extends React.Component<DealerPurchaseSectionProps> {
  buildEquipmentInformation(loanEquipmentInformation: EquipmentInformation): JSX.Element {
    if (this.props.loanDetails.loanType === LoanType.EquipmentAuctionPurchase) {
      return (
        <>
          <span>
            {`${loanEquipmentInformation.year ?? 'N/A'} ${loanEquipmentInformation.make ?? 'N/A'} ${loanEquipmentInformation.model ?? 'N/A'} | Vin/Serial: ${loanEquipmentInformation.vin ?? '--'} | ${loanEquipmentInformation.new ? 'New' : 'Used'}`}
          </span>
        </>
      )
    } else {
      return (
        <>
          <span>
            {loanApplicationUtility.BuildCurrencyAmount(loanEquipmentInformation.totalPrice)}
          </span>
          {loanEquipmentInformation.originalTotalPrice != undefined &&
            <span style={{ fontStyle: 'italic', fontWeight: 'bolder', color: 'green' }}>
              {` (Original Request: ${loanApplicationUtility.BuildCurrencyAmount(loanEquipmentInformation.originalTotalPrice)})`}
            </span>
          }
          <span>
            {` | ${loanEquipmentInformation.year ?? 'N/A'} ${loanEquipmentInformation.make ?? 'N/A'} ${loanEquipmentInformation.model ?? 'N/A'} | Vin/Serial: ${loanEquipmentInformation.vin ?? '--'} | ${loanEquipmentInformation.new ? 'New' : 'Used'} | Quantity: ${loanEquipmentInformation.quantity ?? '--'}, Unit Price: ${loanApplicationUtility.BuildCurrencyAmount(loanEquipmentInformation.unitPrice ?? 0)}`}
          </span>
          {loanEquipmentInformation.originalUnitPrice != undefined &&
            <span style={{ fontStyle: 'italic', fontWeight: 'bolder', color: 'green' }}>
              {` (Original Request: ${loanApplicationUtility.BuildCurrencyAmount(loanEquipmentInformation.originalUnitPrice)})`}
            </span>
          }
        </>
      )
    }
  }

  render() {
    return (
      <>
        {EquipmentLoans.includes(this.props.loanDetails.loanType) && this.props.loanDetails.loanDealerPurchase !== undefined &&
          (<>
            <div>
              <h3>Equipment Purchase Details</h3>
              <Table bordered striped={false} size="sm">
                <tbody>
                  <>
                    <tr>
                      <td width="250px" className="app-info"><strong>Purchase Description</strong></td>
                      <td className="app-info">{this.props.loanDetails.loanDealerPurchase.description}</td>
                    </tr>
                    {this.props.loanDetails.loanType !== LoanType.EquipmentAuctionPurchase &&
                      <tr>
                        <td width="250px" className="app-info"><strong>Purchase Order Amount</strong></td>
                        <td className="app-info">{loanApplicationUtility.BuildCurrencyAmount(this.props.loanDetails.loanDealerPurchase.purchaseAmount)}
                          {this.props.loanDetails.loanDealerPurchase.originalPurchaseAmount != undefined &&
                            <>
                              <span style={{ fontStyle: 'italic', fontWeight: 'bolder', color: 'green' }}>
                                {` (Original Request: ${loanApplicationUtility.BuildCurrencyAmount(this.props.loanDetails.loanDealerPurchase.originalPurchaseAmount)})`}
                              </span>
                            </>
                          }
                        </td>
                      </tr>
                    }

                    {this.props.loanDetails.loanEquipmentInformation?.map((le: EquipmentInformation, i: number) => {
                      return (
                        <tr>
                          <td width="250px" className="app-info"><strong>{`Equipment Item #${i + 1} Information`}</strong></td>
                          <td className="app-info">{this.buildEquipmentInformation(le)}</td>
                        </tr>
                      )
                    })}

                    <tr>
                      <td width="250px" className="app-info"><strong>Equipment Insurance Information</strong></td>
                      <td className="app-info">{`${this.props.loanDetails.loanEquipmentInsuranceInformation?.companyName ?? 'N/A'}, ${this.props.loanDetails.loanEquipmentInsuranceInformation?.agentName ?? 'N/A'}, ${loanApplicationUtility.FormatPhoneNumber(this.props.loanDetails.loanEquipmentInsuranceInformation?.phoneNumber ?? '')}`}</td>
                    </tr>

                    <tr>
                      <td width="250px" className="app-info"><strong>Custom Hire Use</strong></td>
                      <td className="app-info">{this.props.loanDetails.loanDealerPurchase.customHire ? 'Yes' : 'No'}</td>
                    </tr>
                    <tr>
                      <td width="250px" className="app-info"><strong>Total Assets</strong></td>
                      <td className="app-info">{loanApplicationUtility.BuildCurrencyAmount(this.props.loanDetails.loanDealerPurchase.totalAssets)}</td>
                    </tr>
                    <tr>
                      <td width="250px" className="app-info"><strong>Total Liabilities</strong></td>
                      <td className="app-info">{loanApplicationUtility.BuildCurrencyAmount(this.props.loanDetails.loanDealerPurchase.totalLiabilities)}</td>
                    </tr>

                    {this.props.loanDetails.loanType !== LoanType.EquipmentAuctionPurchase &&
                      <>
                        {this.props.loanDetails.loanDealerPurchase.dealerOther != undefined &&
                          <>
                            <tr>
                              <td width="250px" className="app-info"><strong>Dealer/Salesman Information</strong></td>
                              <td className="app-info">{`${this.props.loanDetails.loanDealerPurchase.dealerOther.location}, ${this.props.loanDetails.loanDealerPurchase.dealerOther.name}, ${loanApplicationUtility.FormatPhoneNumber(this.props.loanDetails.loanDealerPurchase.dealerOther.phoneNumber ?? '')}`}</td>
                            </tr>
                          </>
                        }
                        {this.props.loanDetails.loanDealerPurchase.dealerOther == undefined &&
                          <>
                            <tr>
                              <td width="250px" className="app-info"><strong>Dealer Information</strong></td>
                              <td className="app-info">{`#${this.props.loanDetails.loanDealerPurchase.dealerLocation?.id.toString()} ${(this.props.loanDetails.loanDealerPurchase.dealerLocation?.displayName ?? '').length > 0 ? this.props.loanDetails.loanDealerPurchase.dealerLocation?.displayName : this.props.loanDetails.loanDealerPurchase.dealer?.name} ${this.props.loanDetails.loanDealerPurchase.dealerLocation?.city}, ${this.props.loanDetails.loanDealerPurchase.dealerLocation?.state}`}</td>
                            </tr>
                            <tr>
                              <td width="250px" className="app-info"><strong>Salesman Information</strong></td>
                              <td className="app-info">{`#${this.props.loanDetails.loanDealerPurchase.dealerSalesman?.id}, ${this.props.loanDetails.loanDealerPurchase.dealerSalesman?.firstName} ${this.props.loanDetails.loanDealerPurchase.dealerSalesman?.lastName}, ${this.props.loanDetails.loanDealerPurchase.dealerSalesman?.email}, ${loanApplicationUtility.FormatPhoneNumber(this.props.loanDetails.loanDealerPurchase.dealerSalesman?.phoneNumber ?? '')}`}</td>
                            </tr>
                          </>
                        }
                      </>
                    }
                  </>
                </tbody>
              </Table>
            </div>
          </>)
        }
      </>
    );
  }
}